export default {
  // Legacy tokens (usados em outros componentes)
  lightBlue: '#63C3D1',
  darkBlue: '#2F334B',
  lightGray: '#DAE0E3',
  darkGray: '#2e334a',
  error: '#E7344D',
  success: '#388e3c',
  warning: '#FF931E',
  white: '#FFF',
  black: '#000',
  yellowFestGourmet: '#F49F0A',
  bestBlack: '#121212',
  darkAmber: '#D2691E',
  goldenYellow: '#FFD700',
  creamWhite: '#FFF8E7',
  paper: '#F5F5F5',
  // Design tokens — novo estilo mobile-first
  pageBackground: '#ffffff',
  cardBackground: '#f7f2ec',
  primaryOrange: '#c96c1e',
  textDark: '#1a1008',
  textSecondary: '#6b5c4a',
  navBackground: '#1c1c1c',
} as const;
